<template>
  <div class="p-[10px]">
    <el-card
      v-for="(item, index) in message.data.content"
      :key="index"
      :body-style="{ padding: '0px' }"
      class="compact-container mb-[10px]"
    >
      <div class="compact-content">
        <img
          v-if="itemImage(item)"
          :src="itemImage(item)"
          class="image cursor-pointer bg-cover"
          @click="$emit('setLightBoxImage', item.image)"
        />
        <div class="content p-2">
          <span class="kr-title break-words" v-text="item.text" />

          <div class="my-1 mx-0">
            <div
              v-if="
                !shouldShowFullContent[index] &&
                readMoreEnabled &&
                item.subtext?.length > readMoreCharacterCount
              "
            >
              <span
                class="subtext break-words whitespace-pre-line"
                v-html="truncateText(item.subtext)"
              ></span>
              <div class="keyreply-read-more" @click="setShowFullContent(index)">Read More</div>
            </div>
            <span
              v-else
              class="subtext break-words whitespace-pre-line"
              v-html="item.subtext"
            ></span>
          </div>
          <div
            v-for="(button, buttonIndex) in item.buttons"
            :key="buttonIndex"
            class="compact-button text-center block"
          >
            <el-button
              v-if="
                !((button.type && button.type === 'website') || button.url) ||
                isDisabledButton(button) ||
                button.popupWindow?.enabled
              "
              class="kr-button w-full mb-2"
              :class="{ 'blue-button': buttonOutline === 'primary' }"
              v-text="button.text"
              size="small"
              target="_blank"
              :type="buttonOutline"
              :plain="true"
              :disabled="isDisabledButton(button)"
              @click.stop.prevent="onClick($event, button)"
            />
            <a v-else :href="validUrl(button.url)" :target="button.popup ?? '_blank'">
              <el-button
                class="kr-button w-full mb-2"
                :class="{ 'blue-button': buttonOutline === 'primary' }"
                v-text="button.text"
                size="small"
                target="_blank"
                :type="buttonOutline"
                :plain="true"
                @click="onClick($event, button)"
              />
            </a>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import _ from "lodash";
import isDisabledButton from "@/helpers/isDisabledButton";
import validUrl from "@/helpers/validUrl";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      shouldShowFullContent: {},
    };
  },
  props: ["message", "buttonOutline", "shouldDisableIfInLivechat", "backgroundStyle", "titleStyle"],
  methods: {
    validUrl,
    isDisabledButton(button) {
      return isDisabledButton(this, button);
    },
    itemImage(item) {
      const image = item.image || _.get(item, "images[0]");
      return image;
    },
    onClick($event, button) {
      // Handle popup window with custom dimensions
      if (button.url && button.popupWindow?.enabled) {
        $event.preventDefault();
        const width = button.popupWindow.width || 500;
        const height = button.popupWindow.height || 600;
        const windowFeatures = `width=${width},height=${height}`;
        window.open(this.validUrl(button.url), "_blank", windowFeatures);
      }
      const _button = {
        ...button,
        $event,
      };
      this.$emit("sendPostback", _button);
    },
    truncateText(text) {
      if (!text) return "";
      return text.slice(0, this.readMoreCharacterCount) + "...";
    },
    setShowFullContent(index) {
      this.$set(this.shouldShowFullContent, index, true);
    },
  },
  computed: {
    ...mapGetters(["isUiBetaEnabled"]),
    settings() {
      return this.$store.getters.settings;
    },
    readMoreCharacterCount() {
      return this.settings.readMoreConfigure.readMoreCharacterCount;
    },
    readMoreEnabled() {
      return this.settings.readMoreConfigure.enabled;
    },
  },
};
</script>

<style lang="scss" scoped>
.image {
  max-width: 200px;
  width: 40%;
  height: auto;
}

.keyreply-read-more {
  color: var(--keyreply-agent-text-color);
  font-weight: 600;
  font-style: italic;
  cursor: pointer;
}

.ui-beta {
  .compact-container {
    border-radius: 16px;
    overflow: hidden;

    .compact-content {
      display: flex;
    }
    .compact-button {
      text-align: left;
      width: 100%;
      margin-top: 20px;

      .kr-button {
        padding: 8px;
        white-space: normal !important;
        line-height: 18px;
      }
    }
  }

  .image {
    max-width: 200px;
    width: 40%;
  }
  .content {
    flex: 1;
    background: var(--keyreply-user-main-bg-color);

    .kr-title {
      color: var(--keyreply-user-main-title-color);
      font-size: 16px;
      font-weight: 600;
    }

    .subtext {
      font-size: 16px;
      color: #333;
    }
  }
  .kr-button {
    padding: 5px;
    border-radius: 8px;

    &.blue-button {
      border: 1px solid #4e6cce;
      color: #4e6cce;
      background: #fff;

      &:hover {
        color: #fff;
        background: #4e6cce;
      }
    }
  }
}
</style>
